import type { PropsWithChildren } from 'react';

import styles from './TileRow.module.scss';

export function BoardSectionTileRow({ children }: PropsWithChildren) {
	return <div className={styles.row}>{children}</div>;
}
